import React from "react"
import { graphql } from "gatsby"
import { formatLocalDate } from "../../utils/date"

import Image from "../utils/Image"

import Section from "../atoms/Section"
import Flex from "../atoms/Flex"
import Box from "../atoms/Box"
import { Title, Paragraph } from "../atoms/Typography"
import RichText from "../atoms/RichText"

const Article = ({
  title,
  author,
  date,
  displayDate = true,
  section,
  image,
  richText,
}) => {
  if (displayDate === null) displayDate = true

  const formattedDate = formatLocalDate(date, "MMMM d, yyyy") // Render only when we have a valid calendar date

  return (
    <Section {...section}>
      <Flex
        flexDirection={"column"}
        alignItems={"center"}
        position={"relative"}
      >
        <Box
          width={"100%"}
          maxWidth={"968px"}
          maxHeight={"448px"}
          overflow={"hidden"}
        >
          <Image
            alternativeText="Image in An Article"
            imageFieldId={`${section.sectionId}.image`}
            {...image}
          />
        </Box>

        <Box width={{ _: "95%", sm: "80%" }} maxWidth={"704px"}>
          <Title variant={"h1"} pt={6}>
            {title}
          </Title>
          {displayDate && formattedDate && (
            <Paragraph fontSize={0} pt={4}>
              {formattedDate}
            </Paragraph>
          )}
          <Paragraph
            fontSize={0}
            pt={displayDate ? 3 : 4}
            fontWeight="medium"
            mb={7}
          >
            {author}
          </Paragraph>
          <RichText mb={6} isArticle {...richText} section={section} />
        </Box>
      </Flex>
    </Section>
  )
}

export default Article

export const query = graphql`
  fragment Article on STRAPI__COMPONENT_SECTIONS_ARTICLE {
    title
    author
    date
    displayDate
    richText {
      ...RichText
    }
    ARTICLESection: section {
      ...Section
    }
    image {
      ...ImageWith900pxWidth
    }
  }
`
